module.exports = __webpack_public_path__ + "static/media/manage-campaign-icon.74c00f96.svg";